/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'
import { connect } from 'react-redux';

import api from 'api';

import MfaCodeEntryPresenter from './MfaCodeEntry.presenter';

import groupSelectors from 'redux/reduxStore/group';
import ContentPanel from '../../common/ContentPanel';
import { WhiteCardWithWidePadding } from 'components/common/Card/Card';

function mapStateToProps(state) {
  const group = groupSelectors.getActiveGroup(state);

  return {
    organizationName: group.organization_name || '',
  };
}
class MfaCodeEntry extends React.Component {

  constructor(props) {
    super(props);

    this.sendMfaCode = this.sendMfaCode.bind(this);
  }

  sendMfaCode(token) {
    return api.sessionApi.sendMfaCode(token);
  }

  render() {
    return (
      <ContentPanel isFixedWidth titlePhrase={{ id: '2FACodeEntry.title.text' }} subTitle=''>
        <WhiteCardWithWidePadding>
          <MfaCodeEntryPresenter
            {...this.props}
            sendMfaCode={this.sendMfaCode}
          />
        </WhiteCardWithWidePadding>
      </ContentPanel>
    );
  }
}

export default connect(mapStateToProps)(MfaCodeEntry);